const TmpPE028 = (page) => {
  const modifiedPage = {
    ...page
  };

  // Inject page.id into each focus point if present
  if (Array.isArray(page.focusPointsData)) {
    page.focusPointsData.forEach((fp) => {
      fp.page = page.id;
    });
  }

  modifiedPage.title = "Constructed Op Ed Paper";

  // Extract metadata separately
  const metadata = {
    media: [],
    images: [],
    materials: [],
    eMentor: [],
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpPE028;
